import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Default from './components/Default';
import Affid from './components/Affid';
import HourFactor from './components/HourFactor';
import DummyHourFactor from './components/DummyHourFactor';
import API from "../../services/API";

class PcCutoff extends Component {
    constructor() {
        super();

        this.state = {
            loading: {},
        };

        this.setLoading = this.setLoading.bind(this);
        this.setLoaded = this.setLoaded.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    setLoading(name) {
        const loading = { ...this.state.loading };
        loading[name] = 1;

        this.setState({ loading });
    }

    setLoaded(name) {
        const loading = { ...this.state.loading };
        delete loading[name];

        this.setState({ loading });
    }

    handleSync(param) {
        this.setLoading('SYNC');

        API.Sync(['app'], param).then(() => {
            this.setLoaded('SYNC');
        })
    }

    render() {
        return (
            <Container loading={!!Object.keys(this.state.loading).length}>
                <Heading title="PC Cutoff"/>

                <Row>
                    <Col lg={11}>
                        <h3 style={{ marginTop: 0 }}>Default</h3>
                    </Col>
                    <Col lg={1}>
                        <Button bsStyle={'success'} onClick={() => this.handleSync('pcCutoffDefault')}>Sync</Button>
                    </Col>
                </Row>
                <hr/>

                <Default setLoading={this.setLoading} setLoaded={this.setLoaded}/>
                <hr/>

                <Row>
                    <Col lg={11}>
                        <h3 style={{ marginTop: 0 }}>Affid</h3>
                    </Col>
                    <Col lg={1}>
                        <Button bsStyle={'success'} onClick={() => this.handleSync('pcCutoffAffid')}>Sync</Button>
                    </Col>
                </Row>
                <hr/>

                <Affid setLoading={this.setLoading} setLoaded={this.setLoaded}/>
                <hr/>

                <Row>
                    <Col lg={11}>
                        <h3 style={{ marginTop: 0 }}>Hour Factor</h3>
                    </Col>
                    <Col lg={1}>
                        <Button bsStyle={'success'} onClick={() => this.handleSync('pcCutoffHourFactor')}>Sync</Button>
                    </Col>
                </Row>
                <hr/>

                <HourFactor setLoading={this.setLoading} setLoaded={this.setLoaded}/>
                <hr/>
                <Row>
                    <Col lg={11}>
                        <h3 style={{ marginTop: 0 }}>Dummy Hour Factor</h3>
                    </Col>
                    <Col lg={1}>
                        <Button bsStyle={'success'} onClick={() => this.handleSync('dummyCutoffHourFactor')}>Sync</Button>
                    </Col>
                </Row>
                <hr/>

                <DummyHourFactor setLoading={this.setLoading} setLoaded={this.setLoaded}/>
            </Container>
        );
    }
}

export default PcCutoff;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/index.js